import Grid from "@material-ui/core/Grid";
import Bignumber from "./Bignumber";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import ListAltIcon from "@material-ui/icons/ListAlt";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import MaskAndValid from "utils/maskAndValid";

export default function BignumbersPrateleiraInfinita({ data, onClickLabel }) {
  return (
    <Grid container>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Quantidade de pedidos aguardando confirmação"
          value={data.piQtdPedidosAguardandoConfirmacao}
          icon={HourglassEmptyIcon}
          onClickLabel={
            data.piQtdPedidosAguardandoConfirmacao !== 0
              ? () => onClickLabel("aguardando")
              : null
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Quantidade de pedidos confirmados"
          value={data.piQtdPedidosConfirmados}
          icon={ListAltIcon}
          onClickLabel={
            data.piQtdPedidosConfirmados !== 0
              ? () => onClickLabel("confirmados")
              : null
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Valor dos pedidos"
          value={
            data.piValorPedidosConfirmados !== null
              ? "R$" + MaskAndValid.maskPrice(data.piValorPedidosConfirmados)
              : null
          }
          icon={AttachMoneyIcon}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Quantidade de peças"
          value={data.piQtdPecasPedidosConfirmados}
          icon={"ni ni-settings-gear-65"}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Preço médio"
          value={
            data.piPrecoMedioPedidosConfirmados !== null
              ? "R$" +
                MaskAndValid.maskPrice(data.piPrecoMedioPedidosConfirmados)
              : null
          }
          icon={LocalOfferIcon}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Ticket médio"
          value={
            data.piTicketMedioPedidosConfirmados !== null
              ? "R$" +
                MaskAndValid.maskPrice(data.piTicketMedioPedidosConfirmados)
              : null
          }
          icon={ConfirmationNumberIcon}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Bignumber
          label="Peças por atendimento"
          value={MaskAndValid.maskDecimal(
            data.piPecasPorAtendimentoConfirmado,
            2
          )}
          icon="fas fa-boxes"
        />
      </Grid>
    </Grid>
  );
}
